export default __webpack_public_path__ + "static/media/valex.8680f242.png";